module.exports = __webpack_public_path__ + "img/16_maska_klen.20967f3.svg";